import React, { useState, useEffect } from "react";
import "./index.css";
import { BrowserRouter, Route, Switch, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
// Components
import Navbar from "./Components/Navbar";
import Hero from "./Components/Hero";
import Main from "./Components/Main";
import Footer from "./Components/Footer";
import Login from "./Components/Login";
import Sign from "./Components/Sign";
import About from "./Components/About";
import Rate from "./Components/Rate";
import Profile from "./Components/Profile";
import Pricing from "./Components/Pricing";

// img
import team from "./assets/images/team.png";
import mac from "./assets/images/mac.jpeg";
import motivation from "./assets/images/motivation.svg";
import profits from "./assets/images/profits.svg";
import security from "./assets/images/security.svg";
import community from "./assets/images/community.svg";
import analysis from "./assets/images/analysis.png";
import feedback from "./assets/images/feedback.svg";
import MK from "./assets/images/MKK.png";
import WT from "./assets/images/WTT.png";

function App() {
  const mainPackage = {
    images: [mac, security, motivation, profits, community, analysis, feedback],
  };
  return (
    <BrowserRouter>
      <Helmet>
        <title>{window.location.pathname.split("/", 2)}</title>
      </Helmet>
      <Switch>
        <Route path="/Login">
          <Login />
        </Route>
        <Route path="/Register">
          <Sign />
        </Route>
        <Route path="/About">
          <Navbar style />
          <About images={[MK, WT]} />
          <Footer />
        </Route>
        <Route path="/Pricing">
          <Navbar style />
          <Pricing />
          <Footer />
        </Route>
        <Route path="/Rate/:id">
          <Navbar style />
          <Rate />
          <Footer />
        </Route>
        <Route path="/Profile">
          <Navbar style />
          <Profile />
          <Footer />
        </Route>

        <Route path="/">
          <Navbar />
          <Hero img={team} />
          <Main package={mainPackage} />
          <Footer />
        </Route>
      </Switch>
    </BrowserRouter>
  );
}

export default App;
